var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"vap-button",class:[
        {'vap-button-outline' : _vm.outline},
        {'vap-button-rounded' : _vm.rounded},
        {'vap-button-action' : _vm.action},
        {'vap-button-disabled' : _vm.disabled},
        {'vap-button-dotdisabled' : _vm.dotDisabled},
        {'vap-button-working' : _vm.working},
        {'vap-button-iconp' : _vm.icon}
    ],on:{"click":_vm.handleClick}},[(_vm.icon)?_c('div',{staticClass:"vap-button-icon"},[_c('svg',{staticStyle:{"transform":"scale(1.4)","margin-top":"20px","margin-left":"34px"},attrs:{"height":"50","version":"1.1","width":"50","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":_vm.path1}})])]):_vm._e(),_vm._v(" "+_vm._s(_vm.uppercase ? _vm.text.toUpperCase() : _vm.text)+" "),(_vm.working)?_c('div',{staticClass:"vap-button-spinner"},[_c('Spinner',{attrs:{"small":""}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }